<template>
	<div class="sleep-data">
		<div class="sleep-data__table">
			<div class="filter">
				<AppDateRangePicker
					class="filter__date"
					placeholder="Select dates"
					v-model="dateFilter"
					:disabled="loading"
				/>

				<AppButton
					modifier="small-secondary"
					@click="getHistory()"
					:disabled="loading || isApplyDisabled"
				>
					Apply
				</AppButton>
			</div>

			<AppTable
				:fields="fields"
				:dataset="dummy"
				:checkbox="false"
				:loading="loading"
			>
				<template #date_created="{ props: { item } }">
					{{ item.date_created | dateFormatter('ll') }}
				</template>

				<template #time_created="{ props: { item } }">
					{{ item.time_created | time('h:mm') }}
				</template>

				<template #loading>
					<AppLoading/>
				</template>
			</AppTable>

			<div class="sleep-data__pagination">
				<p>
					{{`${sleepRecord.from || ''}-${sleepRecord.to || ''}`}}
				</p>

				<AppCountPicker
					placeholder="Item"
					min="30"
					max="60"
					step="20"
					v-model="count"
					:disabled="loading"
					@change="getHistory()"
				/>

				<AppPagination
					v-model="page"
					:total="sleepRecord.last_page"
					:disabled="loading"
					@change="getHistory(false)"
				/>
			</div>
		</div>

		<div class="sleep-data__side-panel">
			<UserReportForm action="user/getUserProfileDetails"/>

			<div class="sleep-data__data">
				<div class="data">
					<h4 class="data__title">Sleep Data</h4>

					<AppDateRangePicker
						class="data__filter"
						placeholder="from - to"
					>
						Select date
					</AppDateRangePicker>

					<p
						class="clear"
						:disabled="false"
					>
						<a>
							Clear
						</a>
					</p>

					<table class="data__info">
						<tr>
							<td>Bed time</td>
							<td>01:48 AM</td>
						</tr>
						<tr>
							<td>Actual Sleep Time</td>
							<td>02:30 AM</td>
						</tr>
						<tr>
							<td>To Fall Asleep</td>
							<td>47 mins</td>
						</tr>
						<tr>
							<td>Woke up at</td>
							<td>06:27 AM</td>
						</tr>
						<tr>
							<td>Sleep duration</td>
							<td>4hrs 38mins</td>
						</tr>
						<tr>
							<td>Brain Rest</td>
							<td>Perfect</td>
						</tr>
						<tr>
							<td>Emotion before sleep</td>
							<td>Calm</td>
						</tr>
					</table>
				</div>

				<div
					v-if="false"
					class="sleep-data__loading"
				>
					<AppLoading/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { mapFields } from 'vuex-map-fields'
import UserReportForm from './UserReportForm'

export default {
	props: ['id'],

	data () {
		return {
			dateFilter: [ new Date(), new Date() ],
			count: 30,
			page: 1,

			fields: [
				{ name: 'date_created', text: 'Date' },
				{ name: 'time_created', text: 'Time' },
				{ name: 'heartbeat_count', text: 'BPM' },
				{ name: 'ppi', text: 'No of PPI' },
				{ name: 'total_ppi', text: 'Total Sum' },
				{ name: 'stress_level', text: 'Stress Level', style: 'text-transform: capitalize;' },
				{ name: 'emotion_name', text: 'Emotion', style: 'text-transform: capitalize;' }
			],

			dummy: [
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' },
				{ date_created: '2020-09-21', time_created: '10:00 AM', heartbeat_count: '123', ppi: '123', total_ppi: '1234', stress_level: 'High', emotion_name: 'Unpleasant' }
			]
		}
	},

	computed: {
		isApplyDisabled () {
			if (this.dateFilter) return this.dateFilter[0] === null || this.dateFilter[1] === null
			return true
		},

		...mapGetters('user', {
			// calendar: 'getCalendar',
			// calendarLoading: 'getCalendarLoading',
			// daily: 'getDaily',
			// dailyLoading: 'getDailyLoading',
			sleepRecord: 'getSleepRecord',
			loading: 'getSleepRecordLoading'
		})
	},

	created () {
		this.getHistory()
	},

	methods: {
		getHistory (resetPage = true) {
			this.page = resetPage ? 1 : this.page
			let query = `?id=${this.id}&page=${this.page}&count=${this.count}`
			let dateFrom = this.dateFormatter(this.dateFilter[0])
			let dateTo = this.dateFormatter(this.dateFilter[1])
			query += `&date_from=${dateFrom}&date_to=${dateTo}`

			this.$store.dispatch('user/getSleepRecord', query)
		},

		dateFormatter (date, format = 'YYYY-MM-DD') {
			const { filters } = this.$options
			return filters.dateFormatter(date, format)
		}
	},

	components: {
		UserReportForm
	}
}
</script>

<style lang="scss" scoped>
.sleep-data {
	width: 100%;
	display: flex;
	padding-right: 100px;

	.filter {
		display: flex;
		align-items: center;
		margin-bottom: 1em;

		> * { margin-right: 1em; }
		&__date { width: 200px; }
		width: 100%;
	}

	&__table {
		width: 100%;
		margin-right: 1.5em;
		height: 350px;
	}

	&__pagination {
		margin-top: 10px;
		width: 100%;
		display: flex;
		align-items: center;

		> *:first-child { margin-right: auto; }
		> *:not(:first-child) { margin-left: 20px; }
	}

	&__side-panel {
		flex-shrink: 0;
		min-width: 250px;
	}

	&__report {
		padding: .6em;
		border: 1px dashed lighten($default-light, 10%);
		margin-bottom: 1.5em;

		.report {
			&__controls {
				display: flex;
				justify-content: space-between;
				margin: 10px 0;

				> * { width: 48%; }
			}

			&__filter {
				margin: .5em 0;
			}
		}

		.clear {
			text-align: right;
			border: none;
			background: none;
			font-size: .9em;

			a {
				text-decoration: none;
				color: $danger;
			}
		}
	}

	&__report-wrapper { position: relative; }

	&__data {
		position: relative;
		padding: .6em;
		border: 1px dashed lighten($default-light, 10%);

		.data {
			&__title {
				margin-bottom: 1em;
			}

			&__filter {
				margin: .5em 0;
			}

			.clear {
				text-align: right;
				border: none;
				background: none;
				font-size: .9em;

				a {
					text-decoration: none;
					color: $danger;
				}
			}

			&__info {
				table-layout: fixed;

				tr {
					td {
						padding: 1em 0;
						&:first-child {
							padding-right: 1.5em;
						}
					}
				}
			}
		}

	}

	&__emotion-card {
		position: absolute;
		top: 0;
		padding: 10px;
		width: 100%;
		height: 100%;

		.close {
			position: absolute;
			top: 10px;
			right: 10px;
			font-size: 1.2em;
			color: $danger;
			cursor: pointer;
		}
	}

	&__loading {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		background-color: #ffffff77;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
